import { get, post } from '.';

export function CreateMessage(options = {}) {
	return post<any>("/app/api/messages", options);
}

export function FindMessage(messageKey: string, options = {}) {
	return get<any>(`/app/api/messages/${messageKey}`, options);
}

export function GetMessages(options = {}) {
	return get<any>("/app/api/messages", options);
}